import { Link } from 'react-router-dom';
interface Props {
  title: string;
  content?: any;
  link?: string;
  placeHolder?: any;
}

export default function ProfileCard({ title, content, link, placeHolder }: Props) {
  return (
    <div className="bg-white flex flex-col p-5 rounded-2xl gap-6 w-full min-w-[320px] min-h-[256px]">
      <div className="flex flex-row justify-between items-center">
        <p className="text-lg font-extrabold">{title}</p>
        {link && (
          <Link to={link}>
            <p className="text-sm font-medium text-black cursor-pointer hover:text-black/80">View All</p>
          </Link>
        )}
      </div>
      <div className="w-full h-full">{content ? content : placeHolder}</div>
    </div>
  );
}
